// DateRangeFilter.js
// import { ORDER_FILTER_KEYS } from '../Filter';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../../../theme';
import { invoiceStateMap } from '../../../../../utils/labelColorText';
import { INVOICE_PRODUCT_FILTER_KEYS } from '../../Filter';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import cx from 'classnames'; // Importing cx from classnames
import { useDispatch, useSelector } from 'react-redux';
import { useGridFilter } from '../../../../../contexts/GridFilterContext';
import { updateFilter } from '../../../../../newapi/global/filter/gridFilterSlice';

const DynamicTypeFilter = ({params}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const filterKey = params.key;
    const dispatch = useDispatch();

    const { index,id } = useGridFilter();
    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const handleStateToggle = (itemState) => {
        if (filterObject && filterObject.filter) {
            const currentState = filterObject.filter[filterKey];

            // Toggle: if already selected, clear it; otherwise set the new value
            const updatedState = currentState === itemState ? null : itemState;

            // Dispatch the action to update the filter with the single selected state
            dispatch(updateFilter({ index, id, filterKey, value: updatedState }));
        }
    };

  
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1.5,
            }}
        >
            {params.options.map((option,index) => {
                const colorKey = option.color === "blue" ? (theme.palette.mode === "dark" ? "blue" : "primary") : option.color;
                return (
                    <Box
                        className={cx({
                            active: filterObject && filterObject.filter?.[filterKey] === option.value, // Add the 'active' class if state is active
                        })}
                        onClick={() => handleStateToggle(option.value)}
                        key={index + option.label}
                        sx={{
                            height:40,
                            border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] :colors.grey[100]}`,
                            p:0.5,
                            borderRadius:5,
                            display:"flex",
                            alignItems:'center',
                            "&.active " : {
                                background: colors[colorKey][100],
                                border: `1px solid ${colors[colorKey][400]}`,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                lineHeight:"32px",
                                background: colors[colorKey][100],
                                color: colors[colorKey][400],
                                border: `1px solid ${colors[colorKey][400]}`,
                                fontFamily:"Roboto, sans-serif",
                                fontSize:14,
                                fontWeight:500,
                                display:"inline-flex",
                                minWidth:120,
                                px:2,
                                alignItems:"center",
                                justifyContent:"center",
                                borderRadius:4,
                            }}
                        >
                            {t(option.label)}
                        </Box>

                    </Box>
                );
            })}
            
        </Box>
    );
};

export default DynamicTypeFilter;